export enum ConfigurationDocumentType {
	Destinations = 0,
	Home = 1,
	LastMinute = 2,
	Meta = 3,
	TopSlider = 4,
	FirstMinute = 5,
	DestinationMenu = 6,
	Premium = 7,
	HeaderMenu = 8,
	SpecialOffer = 9,
}
